import { caseInsensitiveIncludes, isString } from '@weft/utils';
import type { Country } from 'countries-list';
import { countries } from 'countries-list';
import React, { useCallback } from 'react';
import { AutocompleteSelect } from '../AutoCompleteSelect';

type CountriesSelectProps = Omit<React.ComponentProps<typeof AutocompleteSelect>, 'options'> & {
  textFieldProps?: React.ComponentProps<typeof AutocompleteSelect>['textFieldProps'];
};

export const CountriesSelect = React.forwardRef<unknown, CountriesSelectProps>((props, ref) => {
  const handleOptionLabelGetter = useCallback((option: Country | string) => {
    return isString(option) ? Object.values(countries).find(({ name }) => name?.toLowerCase() === option?.toLowerCase())?.name ?? '' : option.name;
  }, []);

  return (
    <AutocompleteSelect
      ref={ref}
      label="Country / Region"
      options={Object.values(countries)}
      isOptionEqualToValue={(option: Country, value: Country | string) => isString(value) ? caseInsensitiveIncludes(option.name, value) : caseInsensitiveIncludes(option.name, value.name)}
      getOptionLabel={handleOptionLabelGetter}
      renderOption={(renderProps, option: Country) => (
        <li
          className="flex items-center"
          {...renderProps}
        >
          <span className="mr-2">{option.emoji}</span>
          <span>{option.name}</span>
        </li>
      )}
      textFieldProps={{
        placeholder: 'Search country',
      }}
      {...props}
    />
  );
});

export function useCountriesFilter() {
  return useCallback((countryName: string) => {
    return Object.values(countries).find(({ name }) => name?.toLowerCase().includes(countryName?.toLowerCase()));
  }, []);
}